import { useState, useEffect, useLayoutEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAtom } from 'jotai'
import {
    UserSession,
    AdminUser
  } from '../../utils'
  import { Client, Account } from "appwrite";
import ThemeOption from '../../components/ThemeOption'
import DashboardMenu from '../../components/DashboardMenu'
import FileUpload from '../../components/FileUpload'
import RunFunction from '../../components/RunFunction'
import { storage, functions } from '../../appwrite/config'
import LogoLoader from '../../components/LogoLoader';

import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';


const client = new Client()
    .setEndpoint(process.env.REACT_APP_ENDPOINT)
    .setProject(process.env.REACT_APP_PROJECT_ID);

const account = new Account(client);

var mountedLoad = false;


export default function IrrigationAuditor() {
    const navigate = useNavigate()
    const [userSession, setUserSession] = useAtom(UserSession);

    const [isLoading, setIsLoading] = useState(true);
    const [isVisible, setIsVisible] = useState(true);
    

    const params = {
        "keywords": ["chain", "link", "ornamental", "fenc", "gate", "operator", "wood", "steel", "bollard", "barrier", "wedge", "crash", "turnstile", "temporary", "rail"]
    }
    
    useEffect(() => {
        if (!mountedLoad) {
            mountedLoad = true;
        }
    }, []);

    // Set authenticated session on initial page load
    useEffect(() => {
        const checkSession = async () => {
            try {
                const user = await account.get()
                return user
            } catch (error) {
                navigate('/')
            }
        }
        setUserSession(checkSession())
    }, []);

    // Display loading screen while the page loads
    useLayoutEffect(() => {
        const timeoutId = setTimeout(() => {
            setIsLoading(false);
            setTimeout(() => {
                setIsVisible(false);
            }, 750);
        }, 0);
        
        return () => clearTimeout(timeoutId);
    }, []);

    return (<>
        {userSession && <DashboardMenu path="" user={userSession} page={<div className="page-content">
            <h1>Irrigation Auditor</h1>
            <FileUpload multiple type="pdf"/>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    id="panel1-header"
                >
                    <Typography component="span">Advanced Settings <i>(optional)</i></Typography>
                </AccordionSummary>
                <AccordionDetails>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse malesuada lacus ex, sit amet blandit leo lobortis eget.
                </AccordionDetails>
            </Accordion>
            <br/>
            <RunFunction name="bid-scanner" settings={{
                keywords: userSession?.prefs["bid-scanner_keywords"]
            }}/>
        </div>} />}

        {isVisible && !mountedLoad && (<div className={`logo-loader ${!isLoading ? 'hidden' : ''}`}>
            <LogoLoader />
        </div>)}
    </>)
}